import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";

import increaseIcon from "assets/img/report-arrow-increase.png";
import decreaseIcon from "assets/img/report-arrow-decrease.png";

import { NullableNumber, ReportItemType } from "types/Reports";

import { formatValueAndUnitBasedOnTypeInReport } from "../report/utils/reportFormat";
import { getAverageSubject } from "../report/utils/reportString";

const overallAverageTextStyles = StyleSheet.create({
    container: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 5,
    },
    image: {
        position: 'relative',
        width: 16,
        height: 16,
    },
    average: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#333333',
        marginLeft: 3,
    },
    description: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#636363',
        marginLeft: 3,
    },
});

type ReportPDFOverallAverageTextProps = {
    itemType: ReportItemType;
    average: NullableNumber;
    prevAverage: NullableNumber;
    unit: string;
    monthString: string;
};

const ReportPDFOverallAverageText = ({
    itemType,
    average,
    prevAverage,
    unit,
    monthString,
}: ReportPDFOverallAverageTextProps) => {
    const averageDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, average, unit, true);
    const hasSubject = itemType === 'room' || itemType === 'energy' || itemType === 'water';
    const name = hasSubject ? ` of ${getAverageSubject(itemType)}` : '';

    let icon = <></>;

    if (average !== null && prevAverage !== null) {
        if (average > prevAverage) {
            icon = <Image
                style={overallAverageTextStyles.image}
                src={increaseIcon}
            />
        } else if (average < prevAverage) {
            icon = <Image
                style={overallAverageTextStyles.image}
                src={decreaseIcon}
            />
        }
    } else {
        icon = <Image
            style={overallAverageTextStyles.image}
            src=''
        />
    }

    return (
        <View style={overallAverageTextStyles.container}>
            {icon}
            <Text style={overallAverageTextStyles.description}>
                On average,
            </Text>
            <Text style={overallAverageTextStyles.average}>
                {`${averageDisplay}`}
            </Text>
            <Text style={overallAverageTextStyles.description}>
                {`${name} per day ${monthString}.*`}
            </Text>
        </View>
    );
};

export default ReportPDFOverallAverageText;
